function Star6(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M0 240a169.7 169.7 0 0 0 240 0 169.7 169.7 0 0 0-240 0ZM240 0a169.7 169.7 0 0 0 0 240 169.7 169.7 0 0 0 0-240ZM480 240a169.7 169.7 0 0 0-240 0 169.7 169.7 0 0 0 240 0ZM240 480a169.7 169.7 0 0 0 0-240 169.7 169.7 0 0 0 0 240Z"></path></svg>
    )
}

export default Star6